<template>
  <v-data-table
    :headers="headers"
    :items="items"
    :total-items="total"
    :rows-per-page-items="[5, 10, 25]"
    :pagination="pagination"
    :loading="loading"
    class="elevation-1"
    @update:pagination="$emit('update:pagination', $event)"
  >
    <template #items="{ item }">
      <td>{{ item.employee_id || '-' }}</td>
      <td>{{ item.first_name || '-' }}</td>
      <td>{{ item.last_name || '-' }}</td>
      <td>{{ item.position || '-' }}</td>
      <td>{{ item.department || '-' }}</td>
      <td>
        <v-btn small outline color="primary" class="ma-0" @click="$emit('changePassword', item)">{{
          $t('change password')
        }}</v-btn>
      </td>
      <td>
        <v-btn icon small outline color="primary" class="ma-0" @click="$emit('edit', item)">
          <v-icon small>edit</v-icon>
        </v-btn>
      </td>
    </template>
  </v-data-table>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => []
    },
    total: {
      type: Number,
      default: 0
    },
    pagination: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      headers: [
        { text: this.$t('employee_id_abbr'), sortable: false },
        { text: this.$t('first_name'), sortable: false },
        { text: this.$t('surname'), sortable: false },
        { text: this.$t('position'), sortable: false },
        { text: this.$t('Department'), sortable: false },
        { text: this.$t('change password'), sortable: false },
        { text: '', sortable: false }
      ]
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/view/template/tigerpoly/member/MemberTable.vue